/**
 * Version Module.
 */
export const VERSION = '2.2.5'